import { Component } from 'react';
import { connect } from 'react-redux';
import { getSplitIOTreatments } from '../../modules/splitIO_api';
import Constants from '../../constants/constants';

// const USER_TRAFFIC_TYPE = "user";
// const ORGANIZATION_TRAFFIC_TYPE = "org";
// const BUSINESS_GROUP_TRAFFIC_TYPE = "business_group";
const ANNONYMOUS_TRAFFIC_TYPE = 'annonymous';

class SplitIOTreatment extends Component {
  componentDidMount() {
    const { featureName, trafficType, dispatch } = this.props;

    let actualTrafficType = trafficType;
    if (typeof actualTrafficType === 'undefined') {
      actualTrafficType = ANNONYMOUS_TRAFFIC_TYPE;
    }

    dispatch(getSplitIOTreatments(featureName, actualTrafficType));
  }
  render() {
    const { treatments, featureName, treatmentValue, children } = this.props;

    let treatment = 'control';
    if (featureName in Constants.SPLIT_IO_LOCAL_TREATMENTS) {
      treatment = Constants.SPLIT_IO_LOCAL_TREATMENTS[featureName];
    } else if (typeof treatments === 'object' && featureName in treatments) {
      treatment = Constants.SPLITIO_TREATMENT_OVERRIDE ? Constants.SPLITIO_TREATMENT_OVERRIDE : treatments[featureName];
    }
    return children(treatment, featureName, treatmentValue);
  }
}

const withState = connect((state) => {
  const { treatments } = state.splitIO;
  return { treatments };
});

export default withState(SplitIOTreatment);
